import { createRoot } from 'react-dom/client';
import FitnessApp from './components/fitness/FitnessApp.jsx';

let root = null;

export function mountFitnessApp(containerId = 'fitness-root') {
  const container = document.getElementById(containerId);
  if (!container) {
    console.warn(`FitLife: No element with id "${containerId}" found.`);
    return;
  }
  if (!root) {
    root = createRoot(container);
  }
  root.render(<FitnessApp />);
}

export function unmountFitnessApp() {
  if (root) {
    root.unmount();
    root = null;
  }
}

if (typeof document !== 'undefined' && document.getElementById('fitness-root')) {
  mountFitnessApp();
}
